import { DEFAULT_ACCENT_COLOR } from './color.helper';

export const noWrapStyle = 'white-space: nowrap;overflow: hidden;text-overflow: ellipsis;';

export function createUlHtmlString(values: string[]): string {
  return `<ul>${values.map((value) => `<li>${value}</li>`).join('')}</ul>`;
}
export function removeTags(value: string): string {
  if (value === null || value === '') {
    return '';
  }

  // Regular expression to identify HTML tags in
  // the input string. Replacing the identified
  // HTML tag with a null string.
  return value.replace(/(<([^>]+)>)/gi, '');
}

export function strongValue(value: string, html = true) {
  if (!value) {
    return undefined;
  }

  if (html) {
    return `<strong>${value}</strong>`;
  } else {
    return value;
  }
}

export function htmlOut(
  label: string,
  content: unknown,
  options: { contentClass?: string; contentStyle?: string } = {}
): string {
  const contentClassAttribute = options.contentClass ? `class='${options.contentClass}'` : '';
  const contentStyleAttribute = options.contentStyle ? `style='${options.contentStyle}'` : '';

  let contentString = '';
  if (content) {
    contentString = typeof content === 'object' ? JSON.stringify(content) : (content as string);
  }

  return `
   <div style="padding: 4px;">
      <div style="font-weight: bold;">
        ${label}
      </div>
      <div ${contentClassAttribute} ${contentStyleAttribute} >
        ${contentString}
      </div>
   </div>
  `;
}

export function htmlSpaceBetween(...contentStrings: string[]): string {
  return htmlDivs(
    contentStrings,
    'display: flex; gap: 10px;align-items: center;  justify-content: space-between; vertical-align: top; width: 100%'
  );
}

export function htmlFlex(...contentStrings: string[]): string {
  return htmlDivs(contentStrings, flexStyle());
}

/**
 * Erzeugt ein "master" div mit n child divs (ein div pro contentStrings item)
 *
 * @param contentStrings
 * @param masterStyle
 * @param style
 */
export function htmlDivs(contentStrings: string[], masterStyle?: string, style?: string): string {
  const childDivs = contentStrings
    .filter((contentString) => !!contentString)
    .map((contentString) => htmlDiv(contentString, style))
    .join('');
  return htmlDiv(childDivs, masterStyle);
}

export function htmlDiv(contentString: string, style?: string): string {
  const styleInfo = style ? `style='${style}'` : '';
  return `<div ${styleInfo}>${contentString}</div>`;
}

export function htmlBr(...contentStrings: string[]): string {
  return contentStrings.filter((contentString) => !!contentString).join('<br>');
}

export function flexStyle(gap = '12px') {
  return `display: flex; gap: ${gap}; align-items: center;`;
}

export function flexColumnStyle(gap = '12px') {
  return `display: flex; flex-direction: column; gap: ${gap}`;
}

export function createSvg(path: string, fillColor = DEFAULT_ACCENT_COLOR): string {
  return `
  <div style='margin-right: 12px'>
    <svg viewBox='0 0 24 24' width='20' height='20' style='fill: ${fillColor}; vertical-align: text-bottom;'>
      <path d='${path}'></path>
    </svg>
  </div>
  `;
}

export function createSvgFromElement(svgElement: SVGElement, fillColor = DEFAULT_ACCENT_COLOR): string {
  svgElement.style.fill = fillColor;
  svgElement.style.height = '20px';
  svgElement.style.width = '20px';
  return svgElement.outerHTML;
}

export const SERVER_ERROR_MESSAGE = 'Ein Serverfehler ist aufgetreten';

export function looksLikeHtml(value: string): boolean {
  const trimmed = value.trimStart();
  return /^<!doctype\b/i.test(trimmed) || /^<html[\s>]/i.test(trimmed) || /^<head[\s>]/i.test(trimmed);
}
